// frontend/src/store/useMapStore.js
import { create } from "zustand";
import useGameStore from "./useGameStore";
import { EMPTY_ARRAY } from "@utils/constants";

const useMapStore = create((set) => ({
  // UI STATE ONLY - Map interaction state
  hoveredTile: null,
  activeTile: null,
  interactionMode: 'select', // Default to select mode as per documentation
  setInteractionMode: (mode) => set({ interactionMode: mode }),

  // Visual state for map overlays
  visual: {
    highlightTiles: [],     // Tiles highlighted for targeting
    actionPaths: [],        // Action line paths
    conflictTiles: [],      // Conflict indicators
    overlayMode: null,      // Current overlay mode
  },

  setHoveredTile: (tile) => set({ hoveredTile: tile }),
  setActiveTile:   (tile) => set({ activeTile: tile }),
  
  setHighlightTiles: (tiles) =>
    set((s) => ({ visual: { ...s.visual, highlightTiles: tiles } })),

  setActionPaths: (paths) =>
    set((s) => ({ visual: { ...s.visual, actionPaths: paths } })),
  setConflictTiles: (tiles) =>
    set((s) => ({ visual: { ...s.visual, conflictTiles: tiles } })),
  setOverlayMode: (mode) =>
    set((s) => ({ visual: { ...s.visual, overlayMode: mode } })),

  clearVisuals: () =>
    set((s) => ({
      visual: {
        ...s.visual,
        highlightTiles: [],
        actionPaths: [],
        conflictTiles: [],
        animation: [],
      },
    })),

  selectTerrainTiles: () => {
    const layout = useGameStore.getState().game?.map?.layout;
    if (!layout || !Array.isArray(layout)) {
      return EMPTY_ARRAY;
    }
    
    const tiles = [];
    for (let y = 0; y < layout.length; y++) {
      for (let x = 0; x < layout[y].length; x++) {
        tiles.push({ x, y, terrain: layout[y][x] });
      }
    }
    return tiles;
  },
  
}));

export default useMapStore;
